import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import type { TagColor } from '../../types/Tags';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/tags', 'put'>;
type ResponseBody = OASOutput<O, '/api/tags', 'put'>;

type Params = {
  guid: string;
  name?: string | null;
  color?: TagColor;
};

type Result = Params;

export const updateTagFactory = (apiClient: ApiClient) => {
  const updateTag = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/tags'].put(requestBody);
    if (response.status !== 200) {
      throw new Error('Error updating tag');
    }
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        guid: input.guid,
        name: input.name ?? null,
        color: input.color ?? null,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Params): Result => {
    return input;
  };

  return updateTag;
};
